import { render, staticRenderFns } from "./Answeroptions.vue?vue&type=template&id=2c84fe06&"
import script from "./Answeroptions.vue?vue&type=script&lang=js&"
export * from "./Answeroptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports